export const shouldUseReCapcha = (contentAreaItems: Array<any> | null | undefined): boolean => {
  if (!Array.isArray(contentAreaItems) || contentAreaItems.length < 1) {
    return false;
  }

  for (const i of contentAreaItems) {
    if (i?.hasOwnProperty("orderBlock") || i?.hasOwnProperty("formBlock")) {
      return true;
    }
    if (i?.hasOwnProperty("sectionblock")) {
      const columnItems = i?.sectionblock?.columnAreaCollection?.items;
      if (!Array.isArray(columnItems)) {
        continue;
      }

      for (const j of columnItems) {
        if (j?.hasOwnProperty("quizBlock")) {
          return true;
        }
      }
    }
  }
  return false;
};
